<template>
    <div v-bind:class="{ 'mr-2' : !last }" class="flex-1 overflow-hidden rounded">
        <div v-text="title + 's'" class="py-2 text-white bg-primary font-semibold text-xs text-center truncate uppercase rounded-t"></div>
        <div class="bg-primary-light text-primary text-center font-bold text-2xl pt-2 papsi-countdown-h rounded-b">
            <div v-text="value"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'v-countdown-item',
    props: {
        title: {
            type: String,
        },
        value: {
            type: String,
            default: '00',
        },
        last: {
            type: Boolean,
            default: false,
        },
    }
}
</script>

<style scoped>
.papsi-countdown-h {
    height: 48px;
}

.papsi-hithere {
  animation: hithere 1s ease infinite;
}
@keyframes hithere {
  30% { transform: scale(1.2); }
  40%, 60% { transform: rotate(-20deg) scale(1.2); }
  50% { transform: rotate(20deg) scale(1.2); }
  70% { transform: rotate(0deg) scale(1.2); }
  100% { transform: scale(1); }
}
</style>